module.exports = new __parcel__URL__("linkins_armory_level_1.b02b73f1.png").toString();